import { render, staticRenderFns } from "./TroskoviPoVozilima.vue?vue&type=template&id=57ad7849&scoped=true&"
import script from "./TroskoviPoVozilima.vue?vue&type=script&lang=ts&"
export * from "./TroskoviPoVozilima.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad7849",
  null
  
)

export default component.exports